import httpClient from "../http/http-client";
import { IManufacturer } from './manufacturer.model';

export default class ManufacturerService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string): Promise<IManufacturer[]> {
    return this.http.get(`manufacturer${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getOne(manufacturerId: string): Promise<IManufacturer> {
    return this.http.get(`manufacturer/${manufacturerId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }
}